import { useCallback } from 'react';

import { useElements, useStripe } from '@stripe/react-stripe-js';
import type { Stripe, StripeElements } from '@stripe/stripe-js';

type StripeInstances = {
	stripe: Stripe;
	elements: StripeElements;
};

type Result = {
	getStripeInstances: () => StripeInstances;
};

export function useStripeInstances(): Result {
	const elements = useElements();
	const stripe = useStripe();

	const getStripeInstances = useCallback((): StripeInstances => {
		if (!stripe || !elements) {
			throw new Error('Failed to load Stripe library');
		}
		return { stripe, elements };
	}, [stripe, elements]);

	return { getStripeInstances };
}
